// extracted by mini-css-extract-plugin
module.exports = {"singleTrainer":"SingleTrainer_singleTrainer__1xS9-","trainerName":"SingleTrainer_trainerName__1qSox","gymAccess":"SingleTrainer_gymAccess__2jJFP"};